import React, { useState } from 'react';
import { Container, Row, Col, Card, Form, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const MicroATMPOS = () => {
  const [deviceId, setDeviceId] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    // Simulate API call
    setTimeout(() => {
      if (deviceId.trim()) {
        alert(`Device ID ${deviceId} submitted successfully!`);
        setDeviceId('');
      } else {
        alert('Please enter a valid Device ID');
      }
      setIsSubmitting(false);
    }, 1000);
  };

  return (
    <Container fluid className="micro-atm-pos-page p-4">
      {/* Page Header */}
      <div className="page-header mb-4">
        <h2 className="mb-1" style={{ fontSize: '24px' }}>
          <i className="bi bi-credit-card-2-front me-2"></i>
          Micro ATM & POS
        </h2>
        <p className="text-muted mb-0">Register and manage your Micro ATM device</p>
      </div>

      <Row>
        <Col lg={8} className="mx-auto">
          {/* Device Registration Card */}
          <Card className="shadow-sm border-0 mb-4">
            <Card.Body className="p-4" style={{ backgroundColor: '#f8f9fa' }}>
              <h4 className="mb-4" style={{ fontWeight: 600, color: '#333' }}>
                Device Registration
              </h4>

              {/* Instructions */}
              <div className="mb-4">
                <ol className="ps-3 mb-0" style={{ lineHeight: '2' }}>
                  <li style={{ fontSize: '15px', color: '#555' }}>
                    Install Micro ATM application on your mobile (To install it from Play Store{' '}
                    <a 
                      href="https://play.google.com/store" 
                      target="_blank" 
                      rel="noopener noreferrer"
                      style={{ 
                        color: '#0d6efd',
                        textDecoration: 'none',
                        fontWeight: 500
                      }}
                    >
                      CLICK HERE
                    </a>
                    )
                  </li>
                  <li style={{ fontSize: '15px', color: '#555', marginTop: '8px' }}>
                    Open application click on{' '}
                    <i className="bi bi-info-circle-fill" style={{ color: '#0d6efd' }}></i>
                    {' '}button to view Device Identification Number [Device ID]
                  </li>
                </ol>
              </div>

              {/* Device ID Input Section */}
              <div className="mt-4">
                <Form onSubmit={handleSubmit}>
                  <Form.Group className="mb-3">
                    <Form.Label style={{ fontWeight: 500, color: '#555', fontSize: '14px' }}>
                      Your Micro ATM Mapped Device Identification Number [Device ID]
                    </Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter Device ID"
                      value={deviceId}
                      onChange={(e) => setDeviceId(e.target.value)}
                      style={{
                        padding: '12px 16px',
                        fontSize: '15px',
                        border: '1px solid #ddd',
                        borderRadius: '6px'
                      }}
                      required
                    />
                  </Form.Group>

                  {/* Action Buttons */}
                  <div className="d-flex gap-3 mt-4">
                    <Button
                      type="submit"
                      disabled={isSubmitting}
                      style={{
                        backgroundColor: '#2c2268',
                        border: 'none',
                        padding: '12px 32px',
                        borderRadius: '6px',
                        fontWeight: 500,
                        fontSize: '15px',
                        boxShadow: '0 4px 6px rgba(44, 34, 104, 0.2)',
                        transition: 'all 0.3s ease'
                      }}
                      onMouseOver={(e) => {
                        e.currentTarget.style.backgroundColor = '#1e1850';
                        e.currentTarget.style.transform = 'translateY(-2px)';
                        e.currentTarget.style.boxShadow = '0 6px 12px rgba(44, 34, 104, 0.3)';
                      }}
                      onMouseOut={(e) => {
                        e.currentTarget.style.backgroundColor = '#2c2268';
                        e.currentTarget.style.transform = 'translateY(0)';
                        e.currentTarget.style.boxShadow = '0 4px 6px rgba(44, 34, 104, 0.2)';
                      }}
                    >
                      <i className="bi bi-check-circle me-2"></i>
                      {isSubmitting ? 'Submitting...' : 'Submit'}
                    </Button>

                    <Button
                      variant="link"
                      style={{
                        color: '#0d6efd',
                        textDecoration: 'none',
                        fontWeight: 500,
                        fontSize: '15px',
                        padding: '12px 24px'
                      }}
                      onMouseOver={(e) => {
                        e.currentTarget.style.textDecoration = 'underline';
                      }}
                      onMouseOut={(e) => {
                        e.currentTarget.style.textDecoration = 'none';
                      }}
                    >
                      <i className="bi bi-cart me-2"></i>
                      Buy Device
                    </Button>
                  </div>
                </Form>
              </div>
            </Card.Body>
          </Card>

          {/* Additional Info Cards */}
          <Row>
            <Col md={6} className="mb-3">
              <Card className="h-100 border-0 shadow-sm">
                <Card.Body className="text-center p-4">
                  <div 
                    className="mb-3 mx-auto"
                    style={{
                      width: '60px',
                      height: '60px',
                      borderRadius: '50%',
                      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }}
                  >
                    <i className="bi bi-credit-card-2-front" style={{ fontSize: '24px', color: 'white' }}></i>
                  </div>
                  <h5 style={{ fontWeight: 600, marginBottom: '12px' }}>Cash Withdrawal</h5>
                  <p className="text-muted mb-0" style={{ fontSize: '14px' }}>
                    Enable customers to withdraw cash using their cards
                  </p>
                </Card.Body>
              </Card>
            </Col>

            <Col md={6} className="mb-3">
              <Card className="h-100 border-0 shadow-sm">
                <Card.Body className="text-center p-4">
                  <div 
                    className="mb-3 mx-auto"
                    style={{
                      width: '60px',
                      height: '60px',
                      borderRadius: '50%',
                      background: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }}
                  >
                    <i className="bi bi-check2-circle" style={{ fontSize: '24px', color: 'white' }}></i>
                  </div>
                  <h5 style={{ fontWeight: 600, marginBottom: '12px' }}>Balance Inquiry</h5>
                  <p className="text-muted mb-0" style={{ fontSize: '14px' }}>
                    Check account balance instantly for customers
                  </p>
                </Card.Body>
              </Card>
            </Col>

            <Col md={6} className="mb-3">
              <Card className="h-100 border-0 shadow-sm">
                <Card.Body className="text-center p-4">
                  <div 
                    className="mb-3 mx-auto"
                    style={{
                      width: '60px',
                      height: '60px',
                      borderRadius: '50%',
                      background: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }}
                  >
                    <i className="bi bi-receipt" style={{ fontSize: '24px', color: 'white' }}></i>
                  </div>
                  <h5 style={{ fontWeight: 600, marginBottom: '12px' }}>Mini Statement</h5>
                  <p className="text-muted mb-0" style={{ fontSize: '14px' }}>
                    Print mini statements for your customers
                  </p>
                </Card.Body>
              </Card>
            </Col>

            <Col md={6} className="mb-3">
              <Card className="h-100 border-0 shadow-sm">
                <Card.Body className="text-center p-4">
                  <div 
                    className="mb-3 mx-auto"
                    style={{
                      width: '60px',
                      height: '60px',
                      borderRadius: '50%',
                      background: 'linear-gradient(135deg, #fa709a 0%, #fee140 100%)',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }}
                  >
                    <i className="bi bi-graph-up-arrow" style={{ fontSize: '24px', color: 'white' }}></i>
                  </div>
                  <h5 style={{ fontWeight: 600, marginBottom: '12px' }}>Earn Commission</h5>
                  <p className="text-muted mb-0" style={{ fontSize: '14px' }}>
                    Get competitive commission on every transaction
                  </p>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Col>
      </Row>

      {/* Custom Styles */}
      <style jsx="true">{`
        .micro-atm-pos-page {
          background-color: #fff;
          min-height: calc(100vh - 100px);
        }

        .page-header h2 {
          color: #2c2268;
          font-weight: 600;
        }

        .card {
          transition: all 0.3s ease;
        }

        .card:hover {
          transform: translateY(-5px);
          box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1) !important;
        }

        a:hover {
          opacity: 0.8;
        }

        @media (max-width: 768px) {
          .d-flex.gap-3 {
            flex-direction: column;
          }

          .d-flex.gap-3 button {
            width: 100%;
          }
        }
      `}</style>
    </Container>
  );
};

export default MicroATMPOS;

